module.exports = __webpack_public_path__ + "static/img/1.c96e1cdc.png";